import { useEffect, useRef, type RefObject } from 'react';
import { useEscapeLayer } from './back-stack';

// A pop-up menu closes the way menus do everywhere: a tap or click anywhere outside it (or outside the button
// that opened it), or Escape. Escape closes only the menu, never the screen behind it.
export function useDismiss(open: boolean, close: () => void, ...inside: RefObject<HTMLElement | null>[]) {
  const latest = useRef({ close, inside });
  latest.current = { close, inside };
  useEscapeLayer(open, close);
  useEffect(() => {
    if (!open) return;
    const outside = (event: PointerEvent) => {
      const target = event.target as Node;
      if (latest.current.inside.some((ref) => ref.current?.contains(target))) return;
      latest.current.close();
    };
    document.addEventListener('pointerdown', outside, true);
    return () => document.removeEventListener('pointerdown', outside, true);
  }, [open]);
}
